import { render, staticRenderFns } from "./localService.vue?vue&type=template&id=3a4f6fe6&"
import script from "./localService.vue?vue&type=script&lang=js&"
export * from "./localService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4f6fe6')) {
      api.createRecord('3a4f6fe6', component.options)
    } else {
      api.reload('3a4f6fe6', component.options)
    }
    module.hot.accept("./localService.vue?vue&type=template&id=3a4f6fe6&", function () {
      api.rerender('3a4f6fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/localService.vue"
export default component.exports